import React from 'react';
import { Card, Loader } from 'semantic-ui-react';
import { arrayOf, bool, shape, string } from 'prop-types';

import ComingSoon from './ComingSoon';
import Episodes from './Episodes';

const Feed = ({ episodes, loading, terms }) => {
  const now = new Date(new Date() - 18000000);
  const publishedItems = episodes.filter(item => now >= new Date(item.meta));
  const futureItems = episodes.filter(item => now <= new Date(item.meta));
  let nextEpisode = {};
  if (futureItems.length > 0) {
    nextEpisode = futureItems
      .sort((a, b) => new Date(b.date) - new Date(a.date))
      .pop();
  }

  return loading ? (
    <Loader active />
  ) : (
    <Card.Group itemsPerRow={1} centered>
      {nextEpisode.header && (
        <ComingSoon terms={terms} nextEpisode={nextEpisode} />
      )}
      {publishedItems.length > 0 && (
        <Episodes terms={terms} publishedItems={publishedItems} />
      )}
    </Card.Group>
  );
};

Feed.propTypes = {
  episodes: arrayOf(shape).isRequired,
  terms: arrayOf(string).isRequired,
  loading: bool.isRequired,
};

export default Feed;



// WEBPACK FOOTER //
// ./src/components/Feed/Feed.jsx